/**
 * Columns for Hart tables
 * Used in index page and export to keep ordering and labels consistent
 */
export const HART_TABLES_CONFIG = {
  jobs: [
    { field: 'job_no', label: 'Job' },
    { field: 'job_name', label: 'Job Name' },
    { field: 'date_range', label: 'Date Range' },
    { field: 'created', label: 'Create Date' },
    { field: 'close_date', label: 'Close Date' },
    { field: 'job_type', label: 'Job Type' },
    { field: 'has_oversample', label: 'Has OverSample' },
    { field: 'abstract', label: 'Abstract' },
    { field: 'analysts', label: 'Analysts' },
    { field: 'sessions', label: 'Sessions' },
    { field: 'session_types', label: 'Session Type' },
    { field: 'vendor', label: 'Vendors'},
    { field: 'hosts', label: 'Hosts' },
    { field: 'recruiters', label: 'Recruiters' },
    { field: 'job_category', label: 'Job Category' },
    { field: 'firewall_status', label: 'Firewall Status' },
    { field: 'release_status', label: 'Release Status' },
    { field: 'status', label: 'Status' },
  ],
  analysts: [
    { field: 'name', label: 'Analyst Name' },
    { field: 'email', label: 'Email' },
    { field: 'jobs', label: 'Job No' },
  ],
  vendors: [
    { field: 'status', label: 'Status' },
    { field: 'type', label: 'Vendor Type' },
    { field: 'name', label: 'Vendor Name' },
    { field: 'sessions_jobs', label: 'Job No' },
    { field: 'sessions_ids', label: 'Sess ID' },
    { field: 'telephone', label: 'Tel' },
    { field: 'fax', label: 'Fax' },
    { field: 'email', label: 'Email' },
    { field: 'address', label: 'Address' },
    { field: 'city', label: 'City' },
    { field: 'state', label: 'State' },
    { field: 'zip_code', label: 'Zip' },
    { field: 'note', label: 'Note' },
  ],
  clients: [
    { field: 'status', label: 'Status' },
    { field: 'org_id', label: 'Org ID' },
    { field: 'name', label: 'Org Name' },
    { field: 'org_address', label: 'Address' },
    { field: 'org_website', label: 'Website' },
    { field: 'org_phone', label: 'Phone' },
    { field: 'sector', label: 'Sector' },
    { field: 'year_started', label: 'Year Started' },
    { field: 'parent_client', label: 'Parent Organization' },
    { field: 'jobs', label: 'Job No' },
  ],
  facilities: [
    { field: 'status', label: 'Status' },
    { field: 'name', label: 'Facility Name' },
    { field: 'sessions_jobs', label: 'Job No' },
    { field: 'sessions_ids', label: 'Sess ID' },
    { field: 'telephone', label: 'Phone' },
    { field: 'email', label: 'Email' },
    { field: 'address', label: 'Address' },
    { field: 'city', label: 'City' },
    { field: 'state', label: 'State' },
    { field: 'zip_code', label: 'Zip' },
  ],
};

/**
 * Sort configuration for each table type
 * Specifies the column to sort by and the direction
 */
export const HART_TABLES_SORT_CONFIG = {
  jobs: { column: 'job_no', direction: 'desc' },
  analysts: { column: 'name', direction: 'asc' },
  vendors: { column: 'name', direction: 'asc' },
  clients: { column: 'name', direction: 'asc' },
  facilities: { column: 'name', direction: 'asc' },
};